<template>
  <title-comp/>
  <div class="fond">
    <h1>Bienvenue</h1>
    <h1><v-icon style="color: lightslategray;">mdi-account-badge</v-icon></h1>
    <div>{{ username.firstName }}&nbsp;{{ username.lastName }}</div>
  </div>
  <v-container class="prof">
    <v-row no-gutters>
      <v-col>
        <v-img :src='require("@IMG/lynx-prof.png")'></v-img>
      </v-col>
      <v-col>
        <v-img :src='require("@IMG/bulle.png")'>
          <!-- Utilisez la slot par défaut pour ajouter du contenu personnalisé -->
          <div class="d-flex align-start justify-center" style="height: 100%; padding: 5% 5% 5% 35%;">
            <span style="font-size: 4vw;">Pour commencer, appuie sur le menu <v-icon>mdi-menu</v-icon> et choisis ton univers.</span>
          </div>
      </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleComp from '@/components/TitleComp.vue' // Assurez-vous que le chemin est correct
import { AuthStore } from '@/stores'

export default {
  components: {
    TitleComp
  },
  computed: {
    username: function () {
      return AuthStore().AuthInfos.user
    }
  }
}
</script>

<style scoped>
.fond {
  margin-top: 65px;
  vertical-align: bottom;
  width: 100%; /* Couvre toute la largeur */
}

.prof {
  padding-top: 20%;
  border-bottom: 1px solid rgb(226, 226, 226);
}

.bulle {
  background-image: url('@IMG/bulle.png'); /* Remplacez par le chemin de votre image */
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100%;
}
</style>
